import PropTypes from 'prop-types';
// PropTypes globales que se usan muchas veces en el proyecto en distintos componentes
// eslint-disable-next-line import/prefer-default-export
export const EstadoRevision = PropTypes.shape({
  adjuntar: PropTypes.bool,
  colores: PropTypes.string,
  comentario: PropTypes.bool,
  editar: PropTypes.bool,
  estadoCertEnum: PropTypes.number,
  mensaje: PropTypes.string,
  revisionExperta: PropTypes.bool
});

export const Line = PropTypes.shape({
  archivoAdjunto: PropTypes.number,
  estadoRevision: EstadoRevision,
  cantidad: PropTypes.number,
  colores: PropTypes.string,
  comentarios: PropTypes.bool,
  contieneAdjunto: PropTypes.bool,
  descripcionLineaSap: PropTypes.string,
  descripcionLineaYClic: PropTypes.string,
  descripcionPosicionSap: PropTypes.string,
  descripcionPosicionYClic: PropTypes.string,
  disabled: PropTypes.bool,
  estadoEnum: PropTypes.number,
  iconoSincronizacionEnum: PropTypes.number,
  idParteDiario: PropTypes.number,
  idParteLinea: PropTypes.number,
  idPartetrabajo: PropTypes.number,
  idUbicacionLinea: PropTypes.number,
  lineName: PropTypes.string,
  numeroLinea: PropTypes.number,
  numeroPosicion: PropTypes.number,
  positionName: PropTypes.string,
  requiereAdjuntos: PropTypes.bool,
  unidadMedida: PropTypes.string,
  fecha: PropTypes.string
});

export const LineValuesTemplate = PropTypes.shape({
  id: PropTypes.number,
  idLinea: PropTypes.number,
  numeroLinea: PropTypes.number,
  unidadMedida: PropTypes.string,
  descripcionSapLinea: PropTypes.string,
  descripcionYClicLinea: PropTypes.string,
  unidadMedidaCert: PropTypes.string,
  factorConversion: PropTypes.string,
  nombre: PropTypes.string,
  onCall: PropTypes.bool,
  mensualizada: PropTypes.bool
});

export const LineSummary = PropTypes.shape({
  descripcionLineaSap: PropTypes.string,
  descripcionLineaYClic: PropTypes.string,
  descripcionPosicionSap: PropTypes.string,
  descripcionPosicionYClic: PropTypes.string,
  fechaCreacion: PropTypes.string,
  idParteTrabajoLinea: PropTypes.number,
  idPartetrabajo: PropTypes.number,
  numeroLinea: PropTypes.number,
  numeroPosicion: PropTypes.number,
  unidadMedida: PropTypes.string,
  index: PropTypes.number,
  idParteLinea: PropTypes.number
});

export const LineToAPpprove = PropTypes.shape({
  archivoAdjunto: PropTypes.number,
  cantidad: PropTypes.number,
  colores: PropTypes.string,
  comentarios: PropTypes.bool,
  estadoEnum: PropTypes.number,
  estadoRevision: EstadoRevision,
  iconoSincronizacionEnum: PropTypes.number,
  id: PropTypes.number,
  idParteDiario: PropTypes.number,
  nombreDia: PropTypes.string,
  fecha: PropTypes.string
});

export const DetailRequest = PropTypes.shape({
  botonFinalizarServicio: PropTypes.bool,
  estadoEnum: PropTypes.number,
  fechaEvento: PropTypes.string,
  fechaProbableRealizacion: PropTypes.string,
  fechaRespuesta: PropTypes.string,
  grupo: PropTypes.bool,
  iconoSolicitud: PropTypes.oneOfType([
    PropTypes.shape({
      color: PropTypes.string,
      forma: PropTypes.number,
      letra: PropTypes.string
    }),
    PropTypes.number
  ]),
  id: PropTypes.number,
  idLocacion: PropTypes.number,
  nuevoMensaje: PropTypes.bool,
  numero: PropTypes.string,
  numeroContrato: PropTypes.number,
  pasoFechaRespuesta: PropTypes.bool,
  proveedoresAceptados: PropTypes.number,
  proveedoresRechazados: PropTypes.number,
  proveedoresTotales: PropTypes.number,
  servicioDescripcion: PropTypes.string,
  tipoNotificacionEnum: PropTypes.number,
  ubicacionStr: PropTypes.string,
  tipoUbicacion: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  unidadNegocio: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  servicio: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  tipoAsignacion: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  proveedorAsignado: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  })
});

export const DetailRequestMonthly = PropTypes.shape({
  id: PropTypes.number,
  numero: PropTypes.string,
  estadoEnum: PropTypes.number,
  servicio: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  servicioDescripcion: PropTypes.string,
  tipoAsignacion: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }),
  mes: PropTypes.string,
  proveedor: PropTypes.string,
  numeroContrato: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unidadNegocio: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        nombre: PropTypes.string
      })
    ),
    PropTypes.object
  ]),
  nuevoMensaje: PropTypes.bool,
  botonFinalizarServicio: PropTypes.bool,
  tieneUbicaciones: PropTypes.bool,
  tipoNotificacionEnum: PropTypes.number
});

export const partesTrabajoDiarioItemsWorkReport = PropTypes.shape({
  cantidad: PropTypes.number,
  colores: PropTypes.string,
  contieneAdjunto: PropTypes.bool,
  contieneComentarios: PropTypes.bool,
  estadoEnum: PropTypes.number,
  editaAprobador: PropTypes.bool,
  certificaYclick: PropTypes.bool,
  iconoEnum: PropTypes.number,
  idParteDiario: PropTypes.number,
  idParteLinea: PropTypes.number,
  idParteTrabajo: PropTypes.number,
  idParteTrabajoUbicacionLinea: PropTypes.number,
  idProveedor: PropTypes.number,
  lineaSap: PropTypes.string,
  lineaYclic: PropTypes.string,
  posicionSap: PropTypes.string,
  PosicionYclic: PropTypes.string,
  proveedor: PropTypes.string,
  requiereAdjunto: PropTypes.bool,
  revisionExperta: PropTypes.bool,
  tipoAsignacion: PropTypes.number,
  ubicacion: PropTypes.string,
  unidadMedida: PropTypes.string
});

export const itemsWorkReport = PropTypes.arrayOf({
  agrupadoPor: PropTypes.string,
  partesTrabajoDiario: PropTypes.arrayOf(partesTrabajoDiarioItemsWorkReport)
});

export const workReportsProp = PropTypes.arrayOf(
  PropTypes.shape({
    agrupadoPor: PropTypes.string,
    items: itemsWorkReport
  })
);

export const workReportLinesProp = PropTypes.arrayOf(Line);

export const DetailRequestMonthlyDefaultProp = {
  id: 0,
  numero: '',
  estadoEnum: 0,
  servicio: {
    id: 0,
    nombre: ''
  },
  servicioDescripcion: '',
  tipoAsignacion: {
    id: 0,
    nombre: ''
  },
  mes: '',
  proveedor: '',
  numeroContrato: 0,
  unidadNegocio: [],
  nuevoMensaje: false,
  botonFinalizarServicio: false,
  tieneUbicaciones: false,
  tipoNotificacionEnum: 0
};

export const DetailRequestDefaultProp = {
  id: 0,
  numero: '',
  ubicacionStr: '',
  tipoUbicacion: {
    id: 0,
    nombre: ''
  },
  unidadNegocio: {
    id: 0,
    nombre: ''
  },
  servicio: {
    id: 0,
    nombre: ''
  },
  fechaProbableRealizacion: '',
  fechaRespuesta: '',
  servicioDescripcion: '',
  estadoEnum: 0,
  tipoAsignacion: {
    id: 0,
    nombre: ''
  },
  proveedorAsignado: {
    id: 0,
    nombre: ''
  },
  proveedoresAceptados: 0,
  proveedoresRechazados: 0,
  proveedoresTotales: 0,
  pasoFechaRespuesta: false,
  nuevoMensaje: false,
  iconoSolicitud: null
};
